/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Dutch (Netherlands)
export default {
  'team-central.give-jira-kudos.created.description.flag': 'Ons Workplace Experience-team zal nu aan de slag gaan met de aanvraag van het cadeau. ✨',
  'team-central.give-jira-kudos.created.title.flag': 'Kudos aangemaakt',
  'team-central.give-jira-kudos.creation.failed.description.flag': 'We konden je kudos niet aanmaken of het cadeau versturen. Dien een apart ticket in via <a>go/kudos</a>.',
  'team-central.give-jira-kudos.creation.failed.title.flag': 'Er is iets misgegaan',
  'team-central.give-kudos.button': 'Geef kudos',
  'team-central.give-kudos.close-button.label': 'Scherm sluiten',
  'team-central.give-kudos.confirm-close.title': 'Sluiten bevestigen',
  'team-central.give-kudos.created.description.flag': 'Je kudos is verstuurd. <a>Kudos weergeven</a>',
  'team-central.give-kudos.created.title.flag': 'Kudos aangemaakt',
  'team-central.give-kudos.creation.failed.description.flag': 'We konden je kudos niet aanmaken.',
  'team-central.give-kudos.creation.failed.title.flag': 'Er is iets misgegaan',
  'team-central.give-kudos.error-icon.label': 'Fout',
  'team-central.give-kudos.success-icon.label': 'Gelukt',
  'team-central.give-kudos.unsaved.warning': 'Aangebrachte veranderingen worden niet opgeslagen.',
  'team-central.give-kudos.unsaved.warning.cancel': 'Annuleren',
  'team-central.give-kudos.unsaved.warning.close': 'Sluiten'
};